import {useQuery} from '@apollo/client'
import {useTranslation} from 'next-i18next'
import React, {FC, useMemo} from 'react'
import Select from '_app/components/Form/Select'
import {GET_COUNTRIES} from '_app/graphql/queries/customer/GetCountries'
import {handleAvailableCountries} from 'modules/checkout/utils'
import {FormControl} from '@chakra-ui/react'
import {get} from 'lodash-es'
import {useFormContext} from 'react-hook-form'

interface CountriesSelectProps {
    disabled?: boolean;
    name: string;
    shippingCode?: string;
    isRequired?: boolean;
    showAll?: boolean;
    defaultValue?: any;
    selectedCountry?: any;
}

const CountriesSelect: FC<CountriesSelectProps> = ({
   disabled,
   name,
   shippingCode,
   defaultValue,
   isRequired,
   showAll = false,
   selectedCountry,
}) => {
    const { t } = useTranslation('checkout')
    const { data } = useQuery(GET_COUNTRIES)
    const countryOptions = useMemo(() => handleAvailableCountries({data, shippingCode, showAll}), [data, shippingCode, showAll])
    return (
        <FormControl
            isRequired={isRequired}
            isInvalid={!selectedCountry?.billing_address?.region}
            defaultValue={defaultValue}
        >
            <Select
                disabled={disabled}
                errorMessage={!selectedCountry?.billing_address?.region}
                isRequired={true}
                label={t('COUNTRY_LABEL')}
                name={name}
                placeholder={t('COUNTRY_PLACEHOLDER')}
                options={countryOptions}
            />
        </FormControl>
    )
}

export default CountriesSelect
